import { setError } from '@src/shared/zustand';
import { ApiError } from '@src/shared/models';

type NavigationProps = {
  goBack: () => void;
  toHome: (notSetHistory?: boolean) => void;
  toConfirmed: () => void;
  toFaq: () => void;
  toCCB: () => void;
  toError: () => void;
  toErrorSession: () => void;
  toTicket: () => void;
  toErrorEmail: () => void;
  toTerms: () => void;
  toPrivate: () => void;
  toEmailValidation: () => void;
  toReprovedByIdwall: () => void;
  toTimeoutIdwall: () => void;
};

export function goToByError(error: ApiError, navigation: NavigationProps) {
  // Verifica erros de validação de código PIN primeiro (prioridade alta - error codes explícitos)
  if (['PIN_CODE_NOT_FOUND', 'PIN_CODE_INVALID'].includes(error.errorCode)) {
    setError(error.errorCode);
    return;
  }

  if (
    [
      'PIN_CODE_MAX_ATTEMPTS',
      'PIN_CODE_GENERATION_LIMIT',
      'PIN_CODE_GENERATED_LIMIT_REACHED',
    ].includes(error.errorCode)
  ) {
    setError(error.errorCode);
    return navigation.toErrorEmail();
  }

  // Verifica erros de sessão (error codes explícitos)
  if (
    ['SESSION_EXPIRED', 'PROPOSAL_EXPIRED'].includes(error.errorCode) ||
    error.statusCode === 403
  ) {
    setError(error.errorCode);
    return navigation.toErrorSession();
  }

  // Detecta erros relacionados ao IDwall (apenas error codes específicos)
  // Removido substring matching para evitar falsos positivos
  const isIdwallRejection =
    error.errorCode === 'REJECTED' || error.errorCode === 'usuario_reprovado';

  const isIdwallTimeout = error.errorCode === 'IDWALL_TIMEOUT';

  if (isIdwallRejection) {
    setError(error.errorCode);
    return navigation.toReprovedByIdwall();
  }

  if (isIdwallTimeout) {
    setError(error.errorCode);
    return navigation.toTimeoutIdwall();
  }

  // Erro genérico de API - não relacionado a IDwall, sessão ou email
  setError(JSON.stringify(error));
  return navigation.toError();
}
